module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "water-data"
  }, [_c('HeadControl', {
    ref: "HeadControl",
    attrs: {
      "titleName": '流水数据',
      "showorg": false
    },
    on: {
      "changePicker": _vm.changePicker,
      "changDate": _vm.changDate
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "inner-top"
  }, [_c('div', {
    staticClass: "left"
  }, _vm._l((_vm.summaryList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "left-t"
    }, [_c('div', {
      staticClass: "icon"
    }, [_c('img', {
      attrs: {
        "src": item.itemIcon
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "desc"
    }, [_c('div', {
      staticClass: "a-title"
    }, [_vm._v(_vm._s(item.itemName))]), _vm._v(" "), _c('div', {
      staticClass: "amount"
    }, [_vm._v(_vm._s(_vm.aFormat(item.amount))), _c('span', [_vm._v("元")])])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('div', {
    ref: "currentTrend",
    staticStyle: {
      "height": "100%"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "inner-bottom"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "left-t"
  }, [_c('div', {
    staticClass: "a-titel"
  }, [_vm._v("收款类型")]), _vm._v(" "), _c('div', {
    staticClass: "count"
  }, _vm._l((_vm.summaryTypeList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "count-inner"
    }, [_c('div', {
      staticClass: "l-box"
    }, [_c('div', {
      staticClass: "l-t"
    }, [_vm._v(_vm._s(item.itemName))]), _vm._v(" "), _c('div', {
      staticClass: "l-a"
    }, [_vm._v(_vm._s(_vm.aFormat(item.amount))), _c('span', [_vm._v("元")])]), _vm._v(" "), _c('div', {
      staticClass: "l-t"
    }, [_vm._v(_vm._s(item.count) + "笔")])]), _vm._v(" "), _c('div', {
      staticClass: "r-box"
    }, [_c('img', {
      attrs: {
        "src": item.itemIcon
      }
    })])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "left-b"
  }, [_c('div', {
    ref: "proportion",
    staticStyle: {
      "height": "100%"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('div', {
    ref: "paymenttype",
    staticStyle: {
      "height": "100%"
    }
  })])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a7a122f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/financialData/waterData.vue
// module id = 1669
// module chunks = 471